import localStorage from '~/services/localStorage';

type StringOrUndefined = string | undefined;

// The Cometly script was only injected in the website from Nov 2023 to Jan 2024, but some users may still have
// the localStorage values set.
function getCometlyParams() {
	return {
		cometlyFingerprint: localStorage.getItem(
			'cometlyFingerprint',
		) as StringOrUndefined,
		cometlyToken: localStorage.getItem('cometlyToken') as StringOrUndefined,
	};
}

export default getCometlyParams;
